function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var globalThisRef = null;
function assignRef() {
  // for browser env
  if (typeof window !== 'undefined') {
    globalThisRef = window;
    return;
  }
  // for nodejs env
  if (typeof global !== 'undefined') {
    globalThisRef = global;
    return;
  }
  throw new Error('unable to locate global object');
}

/**
 *
 * @returns {typeof globalThis}
 */
function getGlobalThis$1() {
  if (!globalThisRef) {
    assignRef();
  }
  return globalThisRef;
}
function setGlobalThis$1(specGlobalThis) {
  var _globalThisRef;
  var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var prevShared = null;
  if ((_globalThisRef = globalThisRef) !== null && _globalThisRef !== void 0 && _globalThisRef.__HEL_MICRO_SHARED__) {
    prevShared = globalThisRef.__HEL_MICRO_SHARED__;
  }
  if (merge) {
    globalThisRef = _objectSpread2(_objectSpread2({}, globalThisRef), specGlobalThis);
  } else {
    globalThisRef = specGlobalThis;
  }
  // 避免 resetGlobalThis 被用户调用后，共享数据丢失
  if (prevShared) {
    globalThisRef.__HEL_MICRO_SHARED__ = prevShared;
  }
}

/**
 * 获取 hel 全局单例对象挂载的宿主，现阶段是 window self global
 * 针对浏览器环境后期可能会调整宿主节点
 */
function getHelSingletonHost() {
  return getGlobalThis$1();
}

function okeys$1(map) {
  return Object.keys(map);
}
function getSearch() {
  var getLocSearch = function getLocSearch( /** @type {Location} */location) {
    var locVar = location || {};
    var search = locVar.search || '';
    if (!search) {
      var hash = loc.hash || '';
      var hashSearch = hash.split('?')[1] || '';
      if (hashSearch) {
        search = "?".concat(hashSearch);
      }
    }
    return search;
  };
  try {
    var _getGlobalThis, _getGlobalThis$top;
    return getLocSearch((_getGlobalThis = getGlobalThis$1()) === null || _getGlobalThis === void 0 ? void 0 : (_getGlobalThis$top = _getGlobalThis.top) === null || _getGlobalThis$top === void 0 ? void 0 : _getGlobalThis$top.location);
  } catch (err) {
    var _getGlobalThis2;
    // 可能是非同域的 iframe 载入，访问 iframe 外部变量导致的报错
    return getLocSearch((_getGlobalThis2 = getGlobalThis$1()) === null || _getGlobalThis2 === void 0 ? void 0 : _getGlobalThis2.location);
  }
}
function getLsItem(key) {
  var _getGlobalThis3;
  var ls = (_getGlobalThis3 = getGlobalThis$1()) === null || _getGlobalThis3 === void 0 ? void 0 : _getGlobalThis3.localStorage;
  return ls === null || ls === void 0 ? void 0 : ls.getItem(key);
}
function setLsItem(key, val) {
  var _getGlobalThis4;
  var ls = (_getGlobalThis4 = getGlobalThis$1()) === null || _getGlobalThis4 === void 0 ? void 0 : _getGlobalThis4.localStorage;
  return ls === null || ls === void 0 ? void 0 : ls.setItem(key, val);
}
function getSearchObj() {
  var search = getSearch();
  var map = {};
  if (search !== null && search !== void 0 && search.startsWith('?')) {
    var pureSearch = search.substring(1);
    var items = pureSearch.split('&');
    items.forEach(function (item) {
      var _item$split = item.split('='),
        _item$split2 = _slicedToArray(_item$split, 2),
        key = _item$split2[0],
        value = _item$split2[1];
      map[key] = value;
    });
  }
  return map;
}
function getJsRunLocation() {
  var loc = '';
  try {
    throw new Error('getJsRunLocation');
  } catch (err) {
    /** @type {string[]} */
    var stackArr = err.stack.split('\n');
    var len = stackArr.length;
    // firefox 下 len-1 取不到，需要取 len-2
    loc = stackArr[len - 1] || stackArr[len - 2] || '';
  }
  return loc;
}
function setSubMapValue(rootObj, key, subKey, subValue) {
  var subMap = safeGetMap(rootObj, key);
  subMap[subKey] = subValue;
}
function safeGetMap(rootObj, key) {
  var defaultMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var subMap = rootObj[key];
  if (!subMap) {
    subMap = defaultMap;
    rootObj[key] = subMap;
  }
  return subMap;
}
function safeAssign(assignTo, assignFrom) {
  Object.keys(assignFrom).forEach(function (key) {
    var val = assignFrom[key];
    if (![null, undefined, ''].includes(val)) {
      assignTo[key] = val;
    }
  });
}
function noDupPush$1(oriList, toPush) {
  if (!oriList.includes(toPush)) oriList.push(toPush);
}
function isNull$1(value) {
  var nullDef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _nullDef$nullValues = nullDef.nullValues,
    nullValues = _nullDef$nullValues === void 0 ? [null, undefined, ''] : _nullDef$nullValues,
    _nullDef$emptyObjIsNu = nullDef.emptyObjIsNull,
    emptyObjIsNull = _nullDef$emptyObjIsNu === void 0 ? true : _nullDef$emptyObjIsNu,
    _nullDef$emptyArrIsNu = nullDef.emptyArrIsNull,
    emptyArrIsNull = _nullDef$emptyArrIsNu === void 0 ? true : _nullDef$emptyArrIsNu;
  var inNullValues = nullValues.includes(value);
  if (inNullValues) {
    return true;
  }
  if (Array.isArray(value)) {
    if (emptyArrIsNull) return value.length === 0;
    return false;
  }
  if (_typeof(value) === 'object') {
    var keys = okeys$1(value);
    var keyLen = keys.length;
    if (emptyObjIsNull) return keyLen === 0;
    return false;
  }
  return false;
}

function noop() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
}
function safeParse(jsonStr, defaultValue, errMsg) {
  // 防止传入进来的已经是 json 对象
  if (jsonStr && typeof jsonStr !== 'string') {
    return jsonStr;
  }
  try {
    var result = JSON.parse(jsonStr); // 避免 JSON.parse('null') ---> null
    return result || defaultValue;
  } catch (err) {
    if (defaultValue !== undefined) return defaultValue;
    if (errMsg) throw new Error(errMsg);
    throw err;
  }
}
var isNull = isNull$1;
var noDupPush = noDupPush$1;
var okeys = okeys$1;
function merge2List(list1, list2) {
  var mergedList = [];
  list1.forEach(function (v) {
    return noDupPush(mergedList, v);
  });
  list2.forEach(function (v) {
    return noDupPush(mergedList, v);
  });
  return mergedList;
}
function purify(obj, isValueValid) {
  // isValidVal or isNull
  var isValidFn = isValueValid || function (value) {
    return !isNull(value);
  };
  var pureObj = {};
  okeys(obj).forEach(function (key) {
    if (isValidFn(obj[key])) pureObj[key] = obj[key];
  });
  return pureObj;
}
function getObjsVal(objs, key, backupVal) {
  var val = backupVal;
  var _iterator = _createForOfIteratorHelper(objs),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var mayValidVal = item[key];
      if (![null, undefined, ''].includes(mayValidVal)) {
        val = mayValidVal;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return val;
}

/**
 * for pretty format multi line string when use \`...\`
 * @param {*} mayLineBreakStr
 * @param {'MULTI' | 'ONE'} [mode='MULTI']
 * @returns
 */
function pfstr( /** @type string */mayLineBreakStr) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MULTI';
  var lines = mayLineBreakStr.split('\n');
  var lastIdx = lines.length - 1;
  var formatLine = lines.map(function (line, idx) {
    var _line$trimStart;
    if (!line && (idx === 0 || idx === lastIdx)) {
      return '';
    }
    var replaceBr = function replaceBr( /** @type string */line, hasBrStr) {
      var noBrStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var result = line;
      if (line.endsWith('<br/>')) {
        result = line.substring(0, result.length - 5);
        return "".concat(result).concat(hasBrStr);
      }
      return "".concat(result).concat(noBrStr);
    };
    var result = ((_line$trimStart = line.trimStart) === null || _line$trimStart === void 0 ? void 0 : _line$trimStart.call(line)) || line; // 去头部所有空格
    if (mode === 'MULTI') {
      return "".concat(replaceBr(result, ''), "\n");
    }
    result = replaceBr(result, '\n', ' ');
    return result;
  }).join('');
  return formatLine;
}
function nbstr(mayLineBreakStr) {
  return pfstr(mayLineBreakStr, 'ONE');
}
function nbalert(mayLineBreakStr) {
  var alertInDev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var g = getGlobalThis$1();
  var str = nbstr(mayLineBreakStr);
  var alert = g.alert || noop;
  if (alertInDev && g.location) {
    g.location.port && alert(str);
    return;
  }
  alert(str);
}
function setDataset(el, key, val) {
  if (el.dataset) {
    el.dataset[key] = val;
  } else {
    el.setAttribute("data-".concat(key), val);
  }
}
function disableNode(node) {
  // 只能连续命名，否则会报错
  // failed to set a named property on 'DOMStringMap': 'hel-disabled' is not a valid property name.
  setDataset(node, 'heldisabled', '1');
  node.disabled = true;
}

var commonUtilMod = /*#__PURE__*/Object.freeze({
  __proto__: null,
  noop: noop,
  safeParse: safeParse,
  isNull: isNull,
  noDupPush: noDupPush,
  okeys: okeys,
  merge2List: merge2List,
  purify: purify,
  getObjsVal: getObjsVal,
  pfstr: pfstr,
  nbstr: nbstr,
  nbalert: nbalert,
  setDataset: setDataset,
  disableNode: disableNode
});

function injectPlat(platform, injectOptions) {
  var _this = this;
  var fn = injectOptions.fn,
    fnName = injectOptions.fnName,
    arg1PlatObjFnKeys = injectOptions.arg1PlatObjFnKeys;
  var handleArg1 = arg1PlatObjFnKeys.includes(fnName);
  return function () {
    var mergePlatObj = function mergePlatObj(obj) {
      return _objectSpread2({
        platform: platform
      }, purify(obj || {}));
    };
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var arg1 = args[0],
      arg2 = args[1];
    if (handleArg1) {
      args[0] = mergePlatObj(arg1);
    } else {
      args[1] = mergePlatObj(arg2);
    }
    // @ts-ignore
    return fn.apply(_this, args);
  };
}
function inectPlatToMod$1(platform, mod, options) {
  var _ref = options || {},
    _ref$ignoreKeys = _ref.ignoreKeys,
    ignoreKeys = _ref$ignoreKeys === void 0 ? [] : _ref$ignoreKeys,
    _ref$arg1PlatObjFnKey = _ref.arg1PlatObjFnKeys,
    arg1PlatObjFnKeys = _ref$arg1PlatObjFnKey === void 0 ? [] : _ref$arg1PlatObjFnKey;
  var newObj = {};
  Object.keys(mod).forEach(function (mayFnName) {
    var mayFn = mod[mayFnName];
    if (ignoreKeys.includes(mayFnName)) {
      newObj[mayFnName] = mayFn;
      return;
    }
    var valueType = _typeof(mayFn);
    if (valueType && valueType === 'object') {
      newObj[mayFnName] = inectPlatToMod$1(platform, mayFn, options);
      return;
    }
    if (valueType === 'function') {
      newObj[mayFnName] = injectPlat(platform, {
        arg1PlatObjFnKeys: arg1PlatObjFnKeys,
        fn: mayFn,
        fnName: mayFnName
      });
      return;
    }
    newObj[mayFnName] = mayFn;
  });
  return newObj;
}

var PLAT_HEL$1 = 'hel';
var PLAT_UNPKG$1 = 'unpkg';
var logModeEnum = {
  NONE: 0,
  LOG: 1,
  TRACE: 2
};

/**
 * 第一个载入的版本号，后续接口未指定版本时，总是优先载入一个载入的版本号对应的模块，确保优先使用全局已存在的模块
 * 内部很多地方用，这里额外独立暴露一下
 */
var DEFAULT_ONLINE_VER = '__default_online_ver__';

/** 内部很多地方用，这里额外独立暴露一下  */
var DEFAULT_PLAT = PLAT_UNPKG$1;
var helConsts$1 = {
  CORE_VER: '4.8.5',
  DEFAULT_API_PREFIX: 'https://unpkg.com',
  DEFAULT_API_URL: '/openapi/v1/app/info',
  DEFAULT_ONLINE_VER: DEFAULT_ONLINE_VER,
  DEFAULT_USER_LS_KEY: 'HelUserRtxName',
  DEFAULT_PLAT: DEFAULT_PLAT,
  LS_LOG_MODE: 'HelConfig.logMode',
  LS_LOG_FILTER: 'HelConfig.logFilter',
  PLAT_HEL: PLAT_HEL$1,
  PLAT_UNPKG: PLAT_UNPKG$1,
  /** commonData.CSS_STR ，存放样式字符串 map */
  KEY_CSS_STR: 'CSS_STR',
  /** commonData.ASSET_CTX ，资源对应的具体上下文 */
  KEY_ASSET_CTX: 'ASSET_CTX',
  /** commonData.STYLE_TAG_ADDED ，对应的样式字符串 { [key: 'app-group-name' ]: string } */
  KEY_STYLE_TAG_ADDED: 'STYLE_TAG_ADDED',
  /** commonData.CSS_LINK_TAG_ADDED ，对应的样式url列表 { [key: 'http://localhost:3000' ]: string[] } */
  KEY_CSS_LINK_TAG_ADDED: 'CSS_LINK_TAG_ADDED',
  /** commonData.IGNORE_CSS_PREFIX_LIST ，忽略样式前缀列表 string[] */
  KEY_IGNORE_CSS_PREFIX_LIST: 'IGNORE_CSS_PREFIX_LIST',
  /** commonData.IGNORE_STYLE_TAG_KEY ，忽略样式前缀列表 { [key: string ]: 1|0 } */
  KEY_IGNORE_STYLE_TAG_KEY: 'IGNORE_STYLE_TAG_KEY',
  /** commonData.IGNORE_CSS_PREFIX_2_KEYS ，忽略样式前缀对应的key { [key: 'http://localhost:3000' ]: string } */
  KEY_IGNORE_CSS_PREFIX_2_KEYS: 'IGNORE_CSS_PREFIX_2_KEYS'
};
var helEvents$1 = {
  // renderApp 发射的是 SUB_APP_LOADED
  // 此处有个小写开头的瑕疵不再做纠正，
  SUB_APP_LOADED: 'subAppLoaded',
  // libReady 发射的是 SUB_LIB_LOADED
  SUB_LIB_LOADED: 'SubLibLoaded',
  // 3.2+ 新增样式字符串获取完毕事件
  STYLE_STR_FETCHED: 'StyleStrFetched',
  /** 4.2.3+ 用于监听动态添加的 style 标签，方便上层用到 shadowdom 的地方可以接收样式并转移到 shadowdom 内部 */
  STYLE_TAG_ADDED: 'StyleTagAdded',
  /** 4.2.6+ 用于监听动态添加的 link 标签，方便上层用到 shadowdom 的地方可以接收样式并转移到 shadowdom 内部 */
  CSS_LINK_TAG_ADDED: 'CssLinkTagAdded'
};

/**
 * 作为应用是否加载 或 样式字符串 是否获取的枚举 map
 * @type {{NOT_LOAD:0, LOADING:1, LOADED:2}}
 */
var helLoadStatus$1 = {
  NOT_LOAD: 0,
  LOADING: 1,
  LOADED: 2
};

var LS_LOG_FILTER = helConsts$1.LS_LOG_FILTER,
  LS_LOG_MODE = helConsts$1.LS_LOG_MODE;
var NONE = logModeEnum.NONE,
  LOG = logModeEnum.LOG,
  TRACE = logModeEnum.TRACE;
var inner = {
  isIncludeFilter: function isIncludeFilter(firstArg, logFilter) {
    if (!logFilter.includes(',')) {
      return firstArg.includes(logFilter);
    }
    /** @type {string[]} */
    var filterList = logFilter.split(',');
    return filterList.some(function (item) {
      return firstArg.includes(item);
    });
  },
  getLogFilter: function getLogFilter() {
    return getHelMicroDebug().logFilter;
  },
  setLogFilter: function setLogFilter(value) {
    var memVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    getHelMicroDebug().logFilter = value;
    memVal && setLsItem(LS_LOG_FILTER, value);
  },
  setLogMode: function setLogMode(value) {
    var memVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var modeNum = parseInt(value, 10);
    if ([NONE, LOG, TRACE].includes(modeNum)) {
      getHelMicroDebug().logMode = modeNum;
      memVal && setLsItem(LS_LOG_MODE, modeNum);
    }
  },
  getLogMode: function getLogMode() {
    return getHelMicroDebug().logMode;
  }
};

/** @type {import('../index').IHelMicroDebug} */
var helMicroDebug = {};
function initMicroDebug() {
  if (getHelMicroDebug().isInit) {
    return;
  }
  getHelMicroDebug().isInit = true;
  var searchObj = getSearchObj();
  var hellog = searchObj.hellog,
    hellogf = searchObj.hellogf;

  // 优先读 url 上的控制参数 hellog，再读 localStorage 里的控制参数
  var logMode = hellog || getLsItem(LS_LOG_MODE) || NONE;
  inner.setLogMode(logMode, false);

  // 优先读 url 上的控制参数 hellogf
  var logFilter = hellogf || getLsItem(LS_LOG_FILTER) || '';
  inner.setLogFilter(logFilter, false);
}

/**
 * @returns {import('../index').IHelMicroDebug}
 */
function makeHelMicroDebug() {
  return {
    logMode: NONE,
    logFilter: '',
    isInit: false
  };
}
function ensureHelMicroDebug() {
  helMicroDebug = getHelSingletonHost().__HEL_MICRO_DEBUG__;
  if (!isNull$1(helMicroDebug)) {
    // 兼容老版本库生成的 __HEL_MICRO_DEBUG__ 对象
    if (helMicroDebug.logMode === undefined) {
      helMicroDebug.logMode = NONE;
      helMicroDebug.logFilter = '';
    }
    return;
  }
  helMicroDebug = makeHelMicroDebug();
  getHelSingletonHost().__HEL_MICRO_DEBUG__ = helMicroDebug;
  try {
    initMicroDebug();
  } catch (err) {}
}

/** 采用缓存一次值后便不再从 search 推导的策略，方便单页面应用路由变化后，依然可以打印log */
function allowLog$1() {
  return inner.getLogMode() !== NONE;
}
function getHelMicroDebug() {
  return helMicroDebug;
}
var logPrefix = '  %c--> HEL LOG:';
var colorDesc = 'color:#ad4e00;font-weight:600';
function log$1() {
  if (!allowLog$1()) {
    return;
  }
  var logFn = inner.getLogMode() === LOG ? console.log : console.trace || console.log;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var firstArg = args[0],
    rest = args.slice(1);
  if (typeof firstArg !== 'string') {
    return logFn.apply(void 0, [logPrefix, colorDesc].concat(args));
  }
  var logFilter = inner.getLogFilter();
  var logParams = ["".concat(logPrefix, " ").concat(firstArg), colorDesc].concat(_toConsumableArray(rest));
  if (logFilter) {
    inner.isIncludeFilter(firstArg, logFilter) && logFn.apply(void 0, _toConsumableArray(logParams));
    return;
  }
  logFn.apply(void 0, _toConsumableArray(logParams));
}

var DEFAULT_API_URL = helConsts$1.DEFAULT_API_URL,
  DEFAULT_USER_LS_KEY = helConsts$1.DEFAULT_USER_LS_KEY,
  PLAT_HEL = helConsts$1.PLAT_HEL,
  PLAT_UNPKG = helConsts$1.PLAT_UNPKG,
  DEFAULT_API_PREFIX = helConsts$1.DEFAULT_API_PREFIX,
  CORE_VER = helConsts$1.CORE_VER,
  KEY_CSS_LINK_TAG_ADDED$1 = helConsts$1.KEY_CSS_LINK_TAG_ADDED,
  KEY_STYLE_TAG_ADDED$1 = helConsts$1.KEY_STYLE_TAG_ADDED,
  KEY_IGNORE_CSS_PREFIX_LIST$1 = helConsts$1.KEY_IGNORE_CSS_PREFIX_LIST,
  KEY_IGNORE_STYLE_TAG_KEY$1 = helConsts$1.KEY_IGNORE_STYLE_TAG_KEY,
  KEY_IGNORE_CSS_PREFIX_2_KEYS$1 = helConsts$1.KEY_IGNORE_CSS_PREFIX_2_KEYS;
function makeOriginOptions(presetOptions) {
  var _ref = presetOptions || {},
    apiPrefix = _ref.apiPrefix;
  return {
    apiMode: 'get',
    apiPrefix: apiPrefix,
    apiSuffix: '',
    apiPathOfApp: DEFAULT_API_URL,
    apiPathOfAppVersion: '',
    getSubAppAndItsVersionFn: null,
    onFetchMetaFailed: null,
    strictMatchVer: true,
    getUserName: null,
    userLsKey: DEFAULT_USER_LS_KEY,
    shouldUseGray: null,
    trustAppNames: null,
    semverApi: null,
    hook: {}
  };
}
function makeCacheNode(platform) {
  /** @type {import('../index').SharedCache} */
  var cacheNode = _objectSpread2(_objectSpread2({
    isConfigOverwrite: false,
    platform: platform,
    appName2Comp: {},
    appName2Lib: {},
    appName2isLibAssigned: {},
    appName2EmitApp: {},
    appName2verLoadStatus: {},
    appName2verEmitLib: {},
    appName2verEmitApp: {},
    appName2verStyleStr: {},
    appName2verStyleFetched: {},
    appName2verExtraCssList: {},
    appName2verAppVersion: {},
    appName2verCustomData: {},
    appName2app: {},
    appName2appVersion: {},
    appName2styleStr: {},
    appGroupName2firstVer: {},
    isOriginInitCalled: false
  }, makeOriginOptions()), {}, {
    origin: makeOriginOptions({
      apiPrefix: DEFAULT_API_PREFIX
    }) // originInit 写入到此对象下
  });

  return cacheNode;
}
function makeEventBus() {
  /** @type {Record<string, any[]>} */
  var name2listeners = {};
  return {
    on: function on(eventName, cb) {
      var listeners = name2listeners[eventName];
      if (!listeners) {
        var arr = [];
        name2listeners[eventName] = arr;
        listeners = arr;
      }
      listeners.push(cb);
    },
    emit: function emit(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var listeners = name2listeners[eventName];
      if (listeners) {
        var listenersCopy = listeners.slice();
        listenersCopy.forEach(function (cb) {
          return cb.apply(void 0, args);
        });
      }
    },
    off: function off(eventName, cb) {
      var listeners = name2listeners[eventName];
      if (listeners) {
        for (var i = 0, len = listeners.length; i < len; i++) {
          var cbItem = listeners[i];
          if (cbItem === cb) {
            listeners.splice(i, 1);
            break;
          }
        }
      }
    }
  };
}
function makeHelMicroShared() {
  var _caches;
  var unpkgCache = makeCacheNode(PLAT_UNPKG);
  var helCache = makeCacheNode(PLAT_HEL);
  var cacheRoot = {
    /**
     * 默认的平台值，这个值在这里已无意义，最新版本的 getPlatform 返回值已固定，不再取此处的值
     * 这里刻意设为 PLAT_HEL 是为了让 3.0 和 4.0 版本包共存时
     * 例如宿主4子模块3这种情况，子模块的旧版本 hel-micro-core 调用 getPlatform 依然能正常获取到 hel 为默认平台
     */
    platform: PLAT_HEL,
    platformHint: 'the platform value here does not make any sense!',
    /** 1.4+ 新增，用于记录 preFetchLib 时显示传递了 platform 值，供 hel-lib-proxy 使用，
     * 方便多平台共同加载包体场景下， exposeLib 接口如果未显式的传递平台值，能尽量正确推测出应用对应的 platform 值
     * 但是这里依然推荐用户 exposeLib 传递具体的平台值，避免推测错误
     */
    appName2platform: {},
    /** 取代 appName2platform，后续 appName2platform 会移出 */
    appGroupName2platform: {},
    /** @type {Record<string, ReturnType<typeof makeCacheNode>>} */
    caches: (_caches = {}, _defineProperty(_caches, PLAT_UNPKG, unpkgCache), _defineProperty(_caches, PLAT_HEL, helCache), _caches),
    /** @type {Record<string, Record<string, any>>} 和应用无关的通用缓存池 */
    common: {}
  };
  var innerEventBus = makeEventBus();
  var userEventBus = makeEventBus();
  return {
    ver: CORE_VER,
    isStyleObInit: false,
    nativeHeadAppend: null,
    nativeBodyAppend: null,
    createFeature: getJsRunLocation(),
    eventBus: innerEventBus,
    userEventBus: userEventBus,
    cacheRoot: cacheRoot,
    /** 指向的是  cacheRoot.caches.unpkg ，放第一层仅用于方便控制台查看，实际业务逻辑还是走 caches 去取 */
    unpkgCache: unpkgCache,
    /** 指向的是  cacheRoot.caches.hel ，放第一层仅用于方便控制台查看，实际业务逻辑还是走 caches 去取 */
    helCache: helCache,
    /** 调试相关函数 */
    dev: {
      setLogMode: inner.setLogMode,
      setLogFilter: inner.setLogFilter
    }
  };
}
function ensureCommonKeys(common) {
  var keys = [KEY_CSS_LINK_TAG_ADDED$1, KEY_STYLE_TAG_ADDED$1, KEY_IGNORE_CSS_PREFIX_LIST$1, KEY_IGNORE_STYLE_TAG_KEY$1, KEY_IGNORE_CSS_PREFIX_2_KEYS$1];
  var getDefault = function getDefault(key) {
    return key === KEY_IGNORE_CSS_PREFIX_LIST$1 ? [] : {};
  };
  keys.forEach(function (key) {
    return safeGetMap(common, key, getDefault(key));
  });
}
function ensureHelMicroShared() {
  var helMicroShared = getHelMicroShared();
  if (helMicroShared) {
    var cacheRoot = helMicroShared.cacheRoot;
    safeGetMap(cacheRoot, 'appGroupName2platform');
    safeGetMap(cacheRoot, 'common');

    // 兼容线上老版本包，遍历 caches 做检测子节点数据结构并补齐
    var caches = cacheRoot.caches;
    Object.keys(caches).forEach(function (key) {
      var cacheNode = caches[key];
      safeGetMap(cacheNode, 'appGroupName2firstVer');
      safeGetMap(cacheNode, 'appName2isLibAssigned');
      safeGetMap(cacheNode, 'appName2verExtraCssList');
      safeGetMap(cacheNode, 'appName2verCustomData');
      safeGetMap(cacheNode, 'hook');
      safeGetMap(cacheNode, 'origin', makeOriginOptions());
      safeGetMap(cacheNode.origin, 'hook');
    });
    ensureCommonKeys(cacheRoot.common);

    // 补齐老包缺失的对象
    if (!helMicroShared.userEventBus) {
      helMicroShared.userEventBus = makeEventBus();
    }
    return;
  }
  helMicroShared = makeHelMicroShared();
  ensureCommonKeys(helMicroShared.cacheRoot.common);
  getHelSingletonHost().__HEL_MICRO_SHARED__ = helMicroShared;
}

/** @return {ReturnType<typeof makeHelMicroShared>} */
function getHelMicroShared() {
  var microShared = getHelSingletonHost().__HEL_MICRO_SHARED__;
  return microShared;
}

/**
 * 获取默认的平台值
 * @returns
 */
function getPlatform$1() {
  // 已不再支持重置平台默认值，上层可用 helMicro.createInstace 接口来定义出自动拉取对应平台的相关接口
  return DEFAULT_PLAT;
}

/**
 * @param {string} platform
 */
function getSharedCache$1(platform) {
  var p = platform || getPlatform$1();
  var cacheRoot = getCacheRoot();
  var cacheNode = cacheRoot.caches[p];
  if (!cacheNode) {
    var platType = _typeof(platform);
    if (platType !== 'string') {
      console.error('invalid plaform:', platform);
      throw new Error("fatal error: platform only can be a string, now it is ".concat(platType));
    }
    var platCache = makeCacheNode(platform);
    cacheRoot.caches[p] = platCache;
    cacheNode = platCache;
  }
  return cacheNode;
}
function getCacheRoot() {
  return getHelMicroShared().cacheRoot;
}

var innerUtil = {
  getCustomData: function getCustomData(appName, customKey, options) {
    var versionId = options.versionId,
      platform = options.platform;
    var _getSharedCache = getSharedCache$1(platform),
      appName2verCustomData = _getSharedCache.appName2verCustomData;
    var customMap = safeGetMap(appName2verCustomData, appName);
    var dataMap = safeGetMap(customMap, customKey);
    return dataMap[versionId || DEFAULT_ONLINE_VER];
  },
  getAppMeta: function getAppMeta(appName, platform) {
    var _getSharedCache2 = getSharedCache$1(platform),
      appName2app = _getSharedCache2.appName2app;
    return appName2app[appName];
  },
  setVerLoadStatus: function setVerLoadStatus(appName, loadStatus, statusMapKey, options) {
    var _ref = options || {},
      versionId = _ref.versionId,
      platform = _ref.platform;
    var appVerLoadStatus = getSharedCache$1(platform)[statusMapKey];
    var versionIdVar = versionId || DEFAULT_ONLINE_VER;
    setSubMapValue(appVerLoadStatus, appName, versionIdVar, loadStatus);
  },
  getVerLoadStatus: function getVerLoadStatus(appName, statusMapKey, options) {
    var _appVerLoadStatus$app;
    var _ref2 = options || {},
      versionId = _ref2.versionId,
      platform = _ref2.platform;
    var appVerLoadStatus = getSharedCache$1(platform)[statusMapKey];
    var versionIdVar = versionId || DEFAULT_ONLINE_VER;
    return ((_appVerLoadStatus$app = appVerLoadStatus[appName]) === null || _appVerLoadStatus$app === void 0 ? void 0 : _appVerLoadStatus$app[versionIdVar]) || helLoadStatus$1.NOT_LOAD;
  },
  // 预防一些未升级的老模块未写 DEFAULT_ONLINE_VER 的值到 libOrAppMap 里
  ensureOnlineModule: function ensureOnlineModule(libOrAppMap, appName, platform) {
    if (libOrAppMap[DEFAULT_ONLINE_VER]) {
      return;
    }
    var appMeta = innerUtil.getAppMeta(appName, platform);
    var onlineModule = libOrAppMap[appMeta === null || appMeta === void 0 ? void 0 : appMeta.online_version];
    if (onlineModule) {
      libOrAppMap[DEFAULT_ONLINE_VER] = onlineModule;
    }
  }
};

function getVerApp$1(appName, inputOptions) {
  var _options$strictMatchV;
  var options = inputOptions || {};
  var versionId = options.versionId,
    platform = options.platform;
  var _getSharedCache = getSharedCache$1(platform),
    appName2verEmitApp = _getSharedCache.appName2verEmitApp,
    appName2Comp = _getSharedCache.appName2Comp,
    strictMatchVer = _getSharedCache.strictMatchVer,
    appName2EmitApp = _getSharedCache.appName2EmitApp;
  var targetStrictMatchVer = (_options$strictMatchV = options.strictMatchVer) !== null && _options$strictMatchV !== void 0 ? _options$strictMatchV : strictMatchVer;
  var verEmitAppMap = safeGetMap(appName2verEmitApp, appName);
  innerUtil.ensureOnlineModule(verEmitAppMap, appName, platform);

  // 不传递具体版本号就指向默认的第一个载入的版本
  var versionIdVar = versionId || DEFAULT_ONLINE_VER;
  var verApp = verEmitAppMap[versionIdVar];
  var Comp = appName2Comp[appName];
  // { Comp } 是为了兼容老包写入的数据，老包未写入 appName2EmitApp
  var legacyWriteVerApp = Comp ? {
    Comp: Comp
  } : null;
  // 指定了版本严格匹配的话，兜底模块置为空
  var fallbackApp = targetStrictMatchVer ? null : appName2EmitApp[appName] || legacyWriteVerApp;
  var result = verApp || fallbackApp || null;
  log$1('[[ core:getVerApp ]] appName,options,result:', appName, options, result);
  return result;
}
function setEmitApp$1(appName, /** @type {import('hel-types').IEmitAppInfo} */emitApp) {
  log$1('[[ core:setEmitApp ]] appName,emitApp:', appName, emitApp);
  var versionId = emitApp.versionId,
    platform = emitApp.platform;
  var sharedCache = getSharedCache$1(platform);
  var appName2verEmitApp = sharedCache.appName2verEmitApp,
    appName2Comp = sharedCache.appName2Comp,
    appName2EmitApp = sharedCache.appName2EmitApp;

  // 记录第一个载入的版本号对应 emitApp
  var verEmitApp = safeGetMap(appName2verEmitApp, appName);
  if (!verEmitApp[DEFAULT_ONLINE_VER]) {
    appName2Comp[appName] = emitApp.Comp;
    appName2EmitApp[appName] = emitApp;
    setSubMapValue(appName2verEmitApp, appName, DEFAULT_ONLINE_VER, emitApp);
  }
  if (versionId) {
    setSubMapValue(appName2verEmitApp, appName, versionId, emitApp);
  }
}

var KEY_CSS_LINK_TAG_ADDED = helConsts$1.KEY_CSS_LINK_TAG_ADDED,
  KEY_STYLE_TAG_ADDED = helConsts$1.KEY_STYLE_TAG_ADDED,
  KEY_IGNORE_CSS_PREFIX_LIST = helConsts$1.KEY_IGNORE_CSS_PREFIX_LIST,
  KEY_IGNORE_STYLE_TAG_KEY = helConsts$1.KEY_IGNORE_STYLE_TAG_KEY,
  KEY_IGNORE_CSS_PREFIX_2_KEYS = helConsts$1.KEY_IGNORE_CSS_PREFIX_2_KEYS;
function getDataMap$1(customKey) {
  var _getCacheRoot = getCacheRoot(),
    common = _getCacheRoot.common;
  var dataMap = safeGetMap(common, customKey);
  return dataMap;
}

/** perf: 内置的 key 已在 microShared 初始化时做了检查，此处可直接获取 */
function getDataNode(customKey) {
  var _getCacheRoot2 = getCacheRoot(),
    common = _getCacheRoot2.common;
  return common[customKey]; // map or list
}

function getCommonData$1(customKey, dataKey) {
  var dataMap = getDataMap$1(customKey);
  var result = dataMap[dataKey];
  return result !== undefined ? result : null;
}
function setCommonData$1(customKey, dataKey, data) {
  var dataMap = getDataMap$1(customKey);
  dataMap[dataKey] = data;
}

/** 操作 commonData 的内置方法集合 */
var commonDataUtil$1 = {
  setIgnoreCssPrefix: function setIgnoreCssPrefix(cssPrefix) {
    var list = getDataNode(KEY_IGNORE_CSS_PREFIX_LIST);
    noDupPush$1(list, cssPrefix);
  },
  setIgnoreStyleTagKey: function setIgnoreStyleTagKey(key) {
    var map = commonDataUtil$1.getIgnoreStyleTagMap();
    map[key] = 1;
  },
  getIgnoreStyleTagMap: function getIgnoreStyleTagMap() {
    var map = getDataNode(KEY_IGNORE_STYLE_TAG_KEY);
    return map;
  },
  setIgnoreCssPrefixKey: function setIgnoreCssPrefixKey(ignoreCssPrefix, key) {
    var list = getCommonData$1(KEY_IGNORE_CSS_PREFIX_2_KEYS, ignoreCssPrefix);
    if (!list) {
      list = [];
      setCommonData$1(KEY_IGNORE_CSS_PREFIX_2_KEYS, ignoreCssPrefix, list);
    }
    noDupPush$1(list, key);
  },
  getIgnoreCssPrefixKeys: function getIgnoreCssPrefixKeys(ignoreCssPrefix) {
    var map = getDataNode(KEY_IGNORE_CSS_PREFIX_2_KEYS);
    return map[ignoreCssPrefix] || [];
  },
  getMatchedIgnoreCssPrefix: function getMatchedIgnoreCssPrefix( /** @type string */url) {
    var ignoreCssPrefixList = getDataNode(KEY_IGNORE_CSS_PREFIX_LIST);
    var matchedPrefix = '';
    for (var i = 0; i < ignoreCssPrefixList.length; i++) {
      var cssPrefix = ignoreCssPrefixList[i];
      if (url.startsWith(cssPrefix)) {
        matchedPrefix = cssPrefix;
        break;
      }
    }
    return matchedPrefix;
  },
  getIgnoreCssPrefixCssUrlList: function getIgnoreCssPrefixCssUrlList(ignoreCssPrefix) {
    var cssUrlList = getCommonData$1(KEY_CSS_LINK_TAG_ADDED, ignoreCssPrefix);
    if (!cssUrlList) {
      cssUrlList = [];
      setCommonData$1(KEY_CSS_LINK_TAG_ADDED, ignoreCssPrefix, cssUrlList);
    }
    return cssUrlList;
  },
  setIgnoreCssPrefixCssUrl: function setIgnoreCssPrefixCssUrl(ignoreCssPrefix, url) {
    var cssUrlList = commonDataUtil$1.getIgnoreCssPrefixCssUrlList(ignoreCssPrefix);
    cssUrlList.push(url);
  },
  getStyleTagText: function getStyleTagText(key) {
    var text = getCommonData$1(KEY_STYLE_TAG_ADDED, key) || '';
    return text;
  },
  clearStyleTagText: function clearStyleTagText(key) {
    setCommonData$1(KEY_STYLE_TAG_ADDED, key, '');
  },
  appendStyleTagText: function appendStyleTagText(key, text) {
    var oldText = commonDataUtil$1.getStyleTagText(key);
    // 继续拼接新的样式字符串
    setCommonData$1(KEY_STYLE_TAG_ADDED, key, "".concat(oldText, " ").concat(text));
  }
};

/** @typedef {import('../../index').IPlatformConfigFull} IPlatformConfigFull */

/**
 * 提取无其他杂项的配置对象
 * @param {SharedCache} mayCache
 * @returns {IPlatformConfigFull}
 */
function getPureConfig(mayCache, needOrigin) {
  var apiMode = mayCache.apiMode,
    apiPrefix = mayCache.apiPrefix,
    apiSuffix = mayCache.apiSuffix,
    apiPathOfApp = mayCache.apiPathOfApp,
    apiPathOfAppVersion = mayCache.apiPathOfAppVersion,
    getSubAppAndItsVersionFn = mayCache.getSubAppAndItsVersionFn,
    onFetchMetaFailed = mayCache.onFetchMetaFailed,
    strictMatchVer = mayCache.strictMatchVer,
    getUserName = mayCache.getUserName,
    userLsKey = mayCache.userLsKey,
    shouldUseGray = mayCache.shouldUseGray,
    getApiPrefix = mayCache.getApiPrefix,
    trustAppNames = mayCache.trustAppNames,
    platform = mayCache.platform,
    origin = mayCache.origin,
    hook = mayCache.hook;
  var toReturn = {
    apiMode: apiMode,
    apiPrefix: apiPrefix,
    apiSuffix: apiSuffix,
    apiPathOfApp: apiPathOfApp,
    apiPathOfAppVersion: apiPathOfAppVersion,
    getSubAppAndItsVersionFn: getSubAppAndItsVersionFn,
    onFetchMetaFailed: onFetchMetaFailed,
    strictMatchVer: strictMatchVer,
    getUserName: getUserName,
    userLsKey: userLsKey,
    shouldUseGray: shouldUseGray,
    getApiPrefix: getApiPrefix,
    trustAppNames: trustAppNames,
    hook: hook,
    platform: platform
  };
  if (needOrigin) {
    toReturn.origin = origin;
  }
  return toReturn;
}
function getPlatformConfig$1(iPlatform) {
  var cache = getSharedCache$1(iPlatform);
  return getPureConfig(cache, true);
}

/**
 *
 * @param {IPlatformConfig} config
 * @param {string} [iPlatform ]
 * @returns
 */
function initPlatformConfig$1( /** @type {import('../index').IPlatformConfig} */config, iPlatform) {
  var cache = getSharedCache$1(iPlatform);
  var pureConfig = getPureConfig(config);
  if (cache.isConfigOverwrite) {
    // 对应平台的 initPlatformConfig 只接受一次调用
    return;
  }
  cache.isConfigOverwrite = true;
  safeAssign(cache, pureConfig);
}
function originInit$1(platform, options) {
  var cache = getSharedCache$1(platform);
  var commonTip = '[[ core:originInit ]] invalid call, it can only been called';
  if (cache.isConfigOverwrite) {
    log$1("".concat(commonTip, " before init"));
    return;
  }
  if (cache.isOriginInitCalled) {
    log$1("".concat(commonTip, " one time"));
    // 对应平台的 initPlatformConfig 只接受一次调用
    return;
  }
  var pureConfig = getPureConfig(options);
  cache.isOriginInitCalled = true;
  safeAssign(cache.origin, pureConfig);
}

/**
 * 优先获取用户为某个应用单独设定的平台值，目前设定的时机有 preFetch、preFetchLib 时指定的平台值
 * 这里是为了辅助 exposeLib 接口未指定平台值时能够动态推导出目标模块的平台值
 * @returns
 */
function getAppPlatform$1(appGroupName) {
  return getCacheRoot().appGroupName2platform[appGroupName] || getPlatform$1();
}

/**
 * hel-micro innerPreFetch 会调用此接口提前记录一下应用名对应的版本号
 */
function setAppPlatform$1(appGroupName, platform) {
  getCacheRoot().appGroupName2platform[appGroupName] = platform;
  return getAppPlatform$1(appGroupName);
}

function getDataMap(appName, options) {
  var customKey = options.customKey,
    platform = options.platform;
  var _getSharedCache = getSharedCache$1(platform),
    appName2verCustomData = _getSharedCache.appName2verCustomData;
  var customMap = safeGetMap(appName2verCustomData, appName);
  var dataMap = safeGetMap(customMap, customKey);
  return dataMap;
}
function getCustomData$1(appName, options) {
  var dataMap = getDataMap(appName, options);
  var result = dataMap[options.versionId || DEFAULT_ONLINE_VER];
  return result !== undefined ? result : null;
}
function setCustomData$1(appName, options) {
  var customValue = options.customValue,
    versionId = options.versionId;
  var dataMap = getDataMap(appName, options);
  dataMap[versionId || DEFAULT_ONLINE_VER] = customValue;
}

var STYLE_TAG_ADDED = helEvents$1.STYLE_TAG_ADDED,
  CSS_LINK_TAG_ADDED = helEvents$1.CSS_LINK_TAG_ADDED;
function getHelEventBus$1() {
  return getHelMicroShared().eventBus;
}
function getUserEventBus$1() {
  return getHelMicroShared().userEventBus;
}
var evName$1 = {
  styleTagAdded: function styleTagAdded(groupName) {
    return "".concat(STYLE_TAG_ADDED, "/").concat(groupName);
  },
  cssLinkTagAdded: function cssLinkTagAdded(host) {
    return "".concat(CSS_LINK_TAG_ADDED, "(").concat(host, ")");
  }
};

function getVerLib$1(appName, inputOptions) {
  var _options$strictMatchV;
  var options = inputOptions || {};
  var versionId = options.versionId,
    platform = options.platform;
  var sharedCache = getSharedCache$1(platform);
  var appName2verEmitLib = sharedCache.appName2verEmitLib,
    appName2Lib = sharedCache.appName2Lib,
    strictMatchVer = sharedCache.strictMatchVer,
    appName2isLibAssigned = sharedCache.appName2isLibAssigned;
  var targetStrictMatchVer = (_options$strictMatchV = options.strictMatchVer) !== null && _options$strictMatchV !== void 0 ? _options$strictMatchV : strictMatchVer;
  var verEmitLibMap = safeGetMap(appName2verEmitLib, appName);
  innerUtil.ensureOnlineModule(verEmitLibMap, appName);

  // 不传递具体版本号就执行默认在线版本
  var versionIdVar = versionId || DEFAULT_ONLINE_VER;
  var verLib = verEmitLibMap[versionIdVar];

  // 未分配的模块，直接返回 null 即可，因为 appName2Lib 里会被 exposeLib 提前注入一个 {} 对象占位
  var staticLib = appName2isLibAssigned[appName] ? appName2Lib[appName] : null;
  // 指定了版本严格匹配的话，兜底模块置为空
  var fallbackLib = targetStrictMatchVer ? null : staticLib;
  var result = verLib || fallbackLib || null;
  log$1('[[ core:getVerLib ]] appName,options,result:', appName, options, result);
  return result;
}
function setEmitLib$1(appName, /** @type {import('hel-types').IEmitAppInfo} */emitApp, options) {
  var _ref = options || {},
    appGroupName = _ref.appGroupName;
  var versionId = emitApp.versionId,
    appProperties = emitApp.appProperties;
  var platform = emitApp.platform || options.platform;
  var sharedCache = getSharedCache$1(platform);
  var appName2verEmitLib = sharedCache.appName2verEmitLib,
    appName2Lib = sharedCache.appName2Lib,
    appName2isLibAssigned = sharedCache.appName2isLibAssigned;
  var appMeta = innerUtil.getAppMeta(appName, platform);
  var assignLibObj = function assignLibObj(appName) {
    // 使用文件头静态导入模块语法时，默认是从 appName2Lib 拿数据，
    // 这意味着 文件头静态导入 总是执行第一个加载的版本模块，
    // （ 注：文件头静态导入对接的是 hel-lib-proxy 的 exposeLib，该接口使用的是 appName2Lib ）
    // 所以 多版本同时导入 和 文件头静态导入 本身是冲突的，用户不应该两种用法一起使用，
    // 否则 文件头静态导入 的模块是不稳定的，除非用户知道后果并刻意这样做
    // marked at 2022-05-06
    var libObj = appName2Lib[appName];
    // 未静态导入时，libObj 是 undefined
    if (!libObj) {
      appName2Lib[appName] = appProperties;
    } else if (_typeof(libObj) === 'object' && Object.keys(libObj).length === 0) {
      // 静态导入时，emptyChunk 那里调用 exposeLib 会提前生成一个 {} 对象
      // 这里只需负责 merge 模块提供方通过 libReady 提供的模块对象
      Object.assign(libObj, appProperties);
    }
    appName2isLibAssigned[appName] = true;
  };
  assignLibObj(appName);
  // 确保 preFetchLib 传入测试应用名时，exposeLib 获取的代理对象能够指到测试库
  // 这样静态导入才能正常工作
  if (appGroupName) {
    assignLibObj(appGroupName);
  } else {
    appMeta && assignLibObj(appMeta.app_group_name);
  }

  // 当前版本可作为默认线上版本来记录
  log$1('[[ core:setEmitLib ]] appMeta:', appMeta);
  var verEmitLibMap = safeGetMap(appName2verEmitLib, appName);
  // 记录第一个载入的版本号对应 lib
  if (!verEmitLibMap[DEFAULT_ONLINE_VER]) {
    setSubMapValue(appName2verEmitLib, appName, DEFAULT_ONLINE_VER, appProperties);
  }
  if (versionId) {
    setSubMapValue(appName2verEmitLib, appName, versionId, appProperties);
  }
}

function getAppMeta$1(appName, platform) {
  var _getSharedCache = getSharedCache$1(platform),
    appName2app = _getSharedCache.appName2app;
  return appName2app[appName];
}
function setAppMeta$1( /** @type {import('hel-types').ISubApp}*/appMeta, platform) {
  var _getSharedCache2 = getSharedCache$1(platform),
    appName2app = _getSharedCache2.appName2app;
  appName2app[appMeta.name] = appMeta;
}

function setVerLoadStatus$1(appName, loadStatus, options) {
  innerUtil.setVerLoadStatus(appName, loadStatus, 'appName2verLoadStatus', options);
}
function getVerLoadStatus$1(appName, options) {
  return innerUtil.getVerLoadStatus(appName, 'appName2verLoadStatus', options);
}
function setVerStyleStrStatus$1(appName, loadStatus, options) {
  innerUtil.setVerLoadStatus(appName, loadStatus, 'appName2verStyleFetched', options);
}
function getVerStyleStrStatus$1(appName, options) {
  return innerUtil.getVerLoadStatus(appName, 'appName2verStyleFetched', options);
}

function getAppStyleStr$1(appName, options) {
  var _appName2verStyleStr$;
  var _ref = options || {},
    platform = _ref.platform,
    versionId = _ref.versionId;
  var _getSharedCache = getSharedCache$1(platform),
    appName2verStyleStr = _getSharedCache.appName2verStyleStr,
    appName2styleStr = _getSharedCache.appName2styleStr;

  // TODO: 暂未考虑接入 strictMatchVer
  var fallbackStyleStr = appName2styleStr[appName] || '';
  // 兼容老包未写 versionId 的情况
  if (!versionId) {
    return fallbackStyleStr;
  }
  return ((_appName2verStyleStr$ = appName2verStyleStr[appName]) === null || _appName2verStyleStr$ === void 0 ? void 0 : _appName2verStyleStr$[versionId]) || fallbackStyleStr || '';
}
function setAppStyleStr$1(appName, str, options) {
  var _ref2 = options || {},
    platform = _ref2.platform,
    versionId = _ref2.versionId;
  var _getSharedCache2 = getSharedCache$1(platform),
    appName2verStyleStr = _getSharedCache2.appName2verStyleStr,
    appName2verStyleFetched = _getSharedCache2.appName2verStyleFetched,
    appName2styleStr = _getSharedCache2.appName2styleStr;
  // 兼容老包未写 versionId 的情况
  if (!versionId) {
    appName2styleStr[appName] = str;
    return;
  }
  setSubMapValue(appName2verStyleStr, appName, versionId, str);
  setSubMapValue(appName2verStyleFetched, appName, versionId, helLoadStatus$1.LOADED);
}
function setVerExtraCssList$1(appName, cssList, inputOptions) {
  var options = inputOptions || {};
  var versionId = options.versionId,
    platform = options.platform;
  var sharedCache = getSharedCache$1(platform);
  var appName2verExtraCssList = sharedCache.appName2verExtraCssList;
  log$1('[[ core:setVerExtraCssList ]] cssList:', cssList);
  var verExtraCssListMap = safeGetMap(appName2verExtraCssList, appName);
  // 记录第一个载入的版本号对应 css 资源
  if (!verExtraCssListMap[DEFAULT_ONLINE_VER]) {
    setSubMapValue(appName2verExtraCssList, appName, DEFAULT_ONLINE_VER, cssList);
  }
  if (versionId) {
    setSubMapValue(appName2verExtraCssList, appName, versionId, cssList);
  }
}
function getVerExtraCssList$1(appName, inputOptions) {
  var options = inputOptions || {};
  var versionId = options.versionId,
    platform = options.platform;
  var sharedCache = getSharedCache$1(platform);
  var appName2verExtraCssList = sharedCache.appName2verExtraCssList;
  var verExtraCssListMap = safeGetMap(appName2verExtraCssList, appName);
  var cssList = verExtraCssListMap[versionId] || verExtraCssListMap[DEFAULT_ONLINE_VER] || [];
  log$1('[[ core:getVerExtraCssList ]] options,cssList:', options, cssList);
  return cssList;
}

function getVersion$1(appName, options) {
  var _appName2verAppVersio;
  var _ref = options || {},
    platform = _ref.platform,
    versionId = _ref.versionId;
  var _getSharedCache = getSharedCache$1(platform),
    appName2verAppVersion = _getSharedCache.appName2verAppVersion,
    appName2appVersion = _getSharedCache.appName2appVersion;

  // TODO: 暂未考虑接入 strictMatchVer
  var firstVerData = appName2appVersion[appName] || null;
  if (!versionId) {
    return firstVerData;
  }
  // firstVerData 在这里作为兜底返回，正常情况下 appName2verAppVersion 肯定是能取到数据的
  return ((_appName2verAppVersio = appName2verAppVersion[appName]) === null || _appName2verAppVersio === void 0 ? void 0 : _appName2verAppVersio[versionId]) || firstVerData;
}
function setVersion$1(appName, /** @type {import('hel-types').ISubAppVersion}*/versionData, options) {
  var _ref2 = options || {},
    platform = _ref2.platform;
  var _getSharedCache2 = getSharedCache$1(platform),
    appName2verAppVersion = _getSharedCache2.appName2verAppVersion,
    appGroupName2firstVer = _getSharedCache2.appGroupName2firstVer,
    appName2appVersion = _getSharedCache2.appName2appVersion;
  var versionId = versionData.sub_app_version;
  if (!versionId) {
    return;
  }
  var appMeta = innerUtil.getAppMeta(appName, platform);
  var verAppVersion = safeGetMap(appName2verAppVersion, appName);
  // 记录第一个载入的版本号对应 versionData
  if (!verAppVersion[DEFAULT_ONLINE_VER]) {
    setSubMapValue(appName2verAppVersion, appName, DEFAULT_ONLINE_VER, versionData);
    appName2appVersion[appName] = versionData;
  }
  setSubMapValue(appName2verAppVersion, appName, versionId, versionData);
  appGroupName2firstVer[appMeta.app_group_name] = versionId;
}

function tryGetVersion$1(appGroupName, platform) {
  // 形如: at c (https://{cdn_host_name}/{platform}/{appname_prefixed_version}/static/js/4.b60c0895.chunk.js:2:44037
  // 用户串改过的话，可能是：at c (https://{user_cdn}/{user_dir1}/{user_dir2 ...}/{platform}/{appname_prefixed_version}/...)
  var loc = getJsRunLocation();
  log$1("[[ core:tryGetVersion ]] may include source > ".concat(loc));
  var _getSharedCache = getSharedCache$1(platform),
    appGroupName2firstVer = _getSharedCache.appGroupName2firstVer;
  var callerSpecifiedVer = appGroupName2firstVer[appGroupName] || '';
  if (loc.includes('https://') || loc.includes('http://')) {
    var _loc$split = loc.split('//'),
      _loc$split2 = _slicedToArray(_loc$split, 2),
      restStr = _loc$split2[1];
    var strList = restStr.split('/');

    // 优先判断可能包含的版本特征
    if (callerSpecifiedVer) {
      if (platform === DEFAULT_PLAT && strList.some(function (item) {
        return item.includes(callerSpecifiedVer);
      })) {
        return callerSpecifiedVer;
      }
      if (strList.includes(callerSpecifiedVer)) {
        return callerSpecifiedVer;
      }
      // strList: ['xxxx.com:8888', 'static', 'js']，本地联调时的特征
      if (strList['1'] === 'static' && strList['2'] === 'js' || strList['1'] === 'js') {
        return callerSpecifiedVer;
      }
    }

    // [ 'unpkg.com' , 'hel-lodash@1.1.0' , ... ]
    if (platform === DEFAULT_PLAT) {
      return strList[1].split('@')[1] || callerSpecifiedVer;
    }

    // 走默认的规则： {cdn_host_name}/{platform}/{appname_prefixed_version}，取下标2对应元素作为版本号
    return strList[2] || callerSpecifiedVer;
  }

  // 在微容器里运行时，js全是在VM里初始化的，此时拿不到具体的加载链接了
  return callerSpecifiedVer;
}
function tryGetAppName$1( /** @type string */version, appGroupName) {
  if (version === DEFAULT_ONLINE_VER) {
    return appGroupName || '';
  }

  // 来自 helpack 管理台的版本号规则
  if (version.includes('_')) {
    // lib-test_20220621165953 ---> lib-test
    var appName = version.substring(0, version.length - 15);
    return appName;
  }

  // 来自 unpkg
  return appGroupName || '';
}

// !!! 注：如果hel-micro hel-micro-core相关包体设置到externals里时，
// 此机制不再有效，建议尽快使用 hel-iso 包替代

// 该变量每个子应用自己维护一份，只能在 __MASTER_APP_LOADED__ 无值时才能被写为true
// __MASTER_APP_LOADED__ 有值表示主应用已挂载
// 需注意此设计模式下，hel-micro-core 不应该被抽到 externals，
// 否则各个应用共同维护一个了 isCoreInit 值，isSubApp 就无效了，需使用 hel-iso 替代
var isMeMarkTrue = false;
var isTryMarkCalled = false;

/**
 * @returns
 */
function tryMarkFlag(clearSignals) {
  if (clearSignals) {
    isMeMarkTrue = false;
    isTryMarkCalled = false;
  }
  if (isTryMarkCalled) {
    return;
  }
  isTryMarkCalled = true;
  var globalThis = getGlobalThis$1();
  if (globalThis.__MASTER_APP_LOADED__ === undefined) {
    globalThis.__MASTER_APP_LOADED__ = true;
    isMeMarkTrue = true;
  }
}

/**
 * 是否是子应用
 * @deprecated
 * @returns
 */
function isSubApp$1() {
  // calling isSubApp is unsafe, cause it will return wrong result when they were lift up to webpack
  // externals, please install hel-iso and call its isSubApp instead
  var tip = 'WARNING: calling isSubApp is unsafe, use hel-iso.isSubApp instead,\n';
  tip += 'more details see: https://tnfe.github.io/hel/docs/tutorial/attention-is-subapp';
  console.log("%c".concat(tip), 'color:red;');
  // __MASTER_APP_LOADED__ 是当前应用写入的，代表当前应用是主应用
  if (isMeMarkTrue) {
    return false;
  }
  return true;
}

function markElFeature( /** @type {HTMLElement} */el, options) {
  var platform = options.platform,
    groupName = options.groupName,
    name = options.name,
    ver = options.ver,
    elName = options.elName;
  setDataset(el, 'el', elName);
  setDataset(el, 'plat', platform);
  setDataset(el, 'gname', groupName);
  setDataset(el, 'name', name);
  setDataset(el, 'ver', ver);
}

var KEY_ASSET_CTX = helConsts$1.KEY_ASSET_CTX;
function doAppend(nativeAppend, /** @type {HTMLLinkElement | HTMLScriptElement}*/el) {
  if (!el || !['LINK', 'SCRIPT'].includes(el.tagName)) {
    return nativeAppend(el);
  }
  var href = el.href,
    tagName = el.tagName,
    src = el.src;
  /** @type string */
  var url = href || src || '';
  var isLink = tagName === 'LINK';
  var assetCtx = getCommonData$1(KEY_ASSET_CTX, url) || {};
  var platform = assetCtx.platform,
    groupName = assetCtx.groupName,
    name = assetCtx.name,
    ver = assetCtx.ver,
    beforeAppend = assetCtx.beforeAppend;
  var mayChangedEl = el;
  if (beforeAppend) {
    var urlKey = isLink ? 'href' : 'src';
    var _url = el.getAttribute(urlKey);
    var setAssetUrl = function setAssetUrl(newUrl) {
      return el.setAttribute(urlKey, newUrl);
    };
    mayChangedEl = beforeAppend({
      el: el,
      nativeAppend: nativeAppend,
      setAssetUrl: setAssetUrl,
      url: _url,
      tagName: tagName
    }) || el;
  }
  var elName = isLink ? 'HelLink' : 'HelScript';
  platform && markElFeature(mayChangedEl, {
    platform: platform,
    groupName: groupName,
    name: name,
    ver: ver,
    elName: elName
  });
  return nativeAppend(mayChangedEl);
}
function patchAppendChild() {
  var helMicroShared = getHelMicroShared();
  var gs = getGlobalThis$1();
  var doc = gs.document;
  var nativeHeadAppend = helMicroShared.nativeHeadAppend;
  var nativeBodyAppend = helMicroShared.nativeBodyAppend;
  // already patched or a mock enviroment
  if (nativeHeadAppend || !doc) {
    return;
  }
  var head = doc.head,
    body = doc.body;
  // record may native appendChild, use bind to avoid Illegal invocation
  nativeHeadAppend = head.appendChild.bind(head);
  nativeBodyAppend = body.appendChild.bind(body);
  helMicroShared.nativeHeadAppend = nativeHeadAppend;
  helMicroShared.nativeBodyAppend = nativeBodyAppend;

  // 兼容一些第三方库对 Element.prototype.appendChild 打了补丁的情况
  var getAppend = function getAppend(nativeAppend, bindTarget) {
    var el = gs.Element;
    return el ? el.prototype.appendChild.bind(bindTarget) : nativeAppend;
  };

  // replace appendChild
  doc.head.appendChild = function (el) {
    return gs.__POWERED_BY_WUJIE__ ? doAppend(nativeHeadAppend, el) : doAppend(getAppend(nativeHeadAppend, head), el);
  };
  doc.body.appendChild = function (el) {
    return gs.__POWERED_BY_WUJIE__ ? doAppend(nativeBodyAppend, el) : doAppend(getAppend(nativeBodyAppend, body), el);
  };
}

function libReady$1(appGroupName, appProperties) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var platform = options.platform || getAppPlatform$1(appGroupName);
  var versionId = options.versionId || tryGetVersion$1(appGroupName, platform);
  var appName = options.appName || tryGetAppName$1(versionId, appGroupName);
  var appMeta = getAppMeta$1(appName, platform);
  // @ts-ignore，来自于用户设定 cust 配置弹射的模块
  if (appMeta !== null && appMeta !== void 0 && appMeta.__fromCust) {
    // 优先读用户透传的版本数据，再读实际对应的在线版本
    versionId = options.versionId || appMeta.online_version;
    appName = appMeta.name;
  }
  var emitLib = {
    platform: platform,
    appName: appName,
    appGroupName: appGroupName,
    versionId: versionId,
    appProperties: appProperties,
    // prettier-ignore
    Comp: function EmptyComp() {},
    lifecycle: {}
  };
  setEmitLib$1(appName, emitLib, {
    appGroupName: appGroupName,
    platform: platform
  });
  setVerLoadStatus$1(appName, helLoadStatus$1.LOADED, {
    versionId: versionId,
    platform: platform
  });
  var eventBus = getHelEventBus$1();
  eventBus.emit(helEvents$1.SUB_LIB_LOADED, emitLib);
}
function appReady$1(appGroupName, Comp) {
  var emitOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lifecycle = emitOptions.lifecycle;
  var platform = emitOptions.platform || getAppPlatform$1(appGroupName);
  var versionId = emitOptions.versionId || tryGetVersion$1(appGroupName, platform);
  var appName = emitOptions.appName || tryGetAppName$1(versionId, appGroupName);
  var emitApp = {
    Comp: Comp,
    appName: appName,
    appGroupName: appGroupName,
    lifecycle: lifecycle,
    platform: platform,
    versionId: versionId,
    isLib: false
  };
  setEmitApp$1(appName, emitApp);
  setVerLoadStatus$1(appName, helLoadStatus$1.LOADED, {
    versionId: versionId,
    platform: platform
  });
  var eventBus = getHelEventBus$1();
  eventBus.emit(helEvents$1.SUB_APP_LOADED, emitApp);
}

var HEL_CSS_MARK_START = '/* @helstart ';
var HEL_CSS_MARK_END = ' @helend */';
var START_LEN = HEL_CSS_MARK_START.length;
function matchIgnoreCssPrefix(node, url) {
  var bus = getHelEventBus$1();
  var matchedPrefix = commonDataUtil$1.getMatchedIgnoreCssPrefix(url);
  // 分析 url ，符合 shadow 特征的不追加 dom，仅发射事件让上层适配层去处理
  if (matchedPrefix) {
    commonDataUtil$1.setIgnoreCssPrefixCssUrl(matchedPrefix, url);
    bus.emit(evName$1.cssLinkTagAdded(matchedPrefix), {
      nodes: [node]
    });
  }
  return matchedPrefix;
}
function resetStyleText(groupName) {
  var g = getGlobalThis$1();
  if (!g) return;
  var list = g.document.head.querySelectorAll("style[data-gname=\"".concat(groupName, "\"]"));
  if (list.length) {
    commonDataUtil$1.clearStyleTagText(groupName);
    list.forEach(function (node) {
      disableNode(node);
      commonDataUtil$1.appendStyleTagText(groupName, node.innerText);
    });
    var bus = getHelEventBus$1();
    bus.emit(evName$1.styleTagAdded(groupName), {
      nodes: list
    });
  }
}
function handleStyleAdded( /** @type {HTMLElement} */node, ignoreStyleTagMap) {
  var tagName = node.tagName,
    innerText = node.innerText,
    href = node.href;
  if (!['STYLE', 'LINK'].includes(tagName)) return;

  // is style tag or link tag
  var isStyleTag = tagName === 'STYLE';
  if (tagName === 'STYLE' && !innerText) {
    return;
  }
  if (isStyleTag) {
    var markStart = innerText.indexOf(HEL_CSS_MARK_START);
    // starts with '/* @helstart '
    if (markStart < 0) {
      return;
    }
    // 处理 css-loader 动态向 heade 添加 style 标签的情况
    // /* @helstart hel-tpl-remote-react-comp-ts @helend */ --> hel-tpl-remote-react-comp-ts
    var markEnd = innerText.indexOf(HEL_CSS_MARK_END);
    if (markEnd < 0) {
      return;
    }
    var helKey = innerText.substring(START_LEN + markStart, markEnd);
    if (helKey) {
      var trimedStr = helKey.trim(); // may groupName or plat/groupName
      var plat = '';
      var groupName = trimedStr;
      if (trimedStr.includes('/')) {
        var arr = trimedStr.split('/');
        plat = arr[0];
        groupName = arr[1];
      }
      setDataset(node, 'gname', groupName);
      plat && setDataset(node, 'plat', plat);
      if (ignoreStyleTagMap[trimedStr]) {
        disableNode(node);
      }
      var bus = getHelEventBus$1();
      commonDataUtil$1.appendStyleTagText(trimedStr, innerText);
      bus.emit(evName$1.styleTagAdded(trimedStr), {
        nodes: [node]
      });
    }
    return;
  }

  // process link tag
  var matchedPrefix = matchIgnoreCssPrefix(node, href);
  if (matchedPrefix) {
    disableNode(node);
  }
}
function handleHotUpdate( /** @type {HTMLElement} */node, ignoreStyleTagMap) {
  var tagName = node.tagName,
    _node$src = node.src,
    src = _node$src === void 0 ? '' : _node$src;
  if (tagName !== 'SCRIPT') return false;
  if (!src.endsWith('.hot-update.js')) return false;
  var matchedPrefix = commonDataUtil$1.getMatchedIgnoreCssPrefix(src);
  if (!matchedPrefix) return false;
  var keys = commonDataUtil$1.getIgnoreCssPrefixKeys(matchedPrefix);
  if (!keys.length) return false;
  var handled = false;
  keys.forEach(function (key) {
    if (ignoreStyleTagMap[key]) {
      resetStyleText(key);
      handled = true;
    }
  });
  return handled;
}
function obStyleTagInsert() {
  var helMicroShared = getHelMicroShared();
  var globalThis = getGlobalThis$1();
  var isStyleObInit = helMicroShared.isStyleObInit;
  var doc = globalThis.document;
  if (isStyleObInit || !doc) {
    return;
  }
  helMicroShared.isStyleObInit = true;
  var ignoreStyleTagMap = commonDataUtil$1.getIgnoreStyleTagMap();
  // @ts-ignore
  var MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver || globalThis.MozMutationObserver;
  if (!MutationObserver) return;
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var addedNodes = mutation.addedNodes,
        removedNodes = mutation.removedNodes;
      var len = addedNodes.length;
      for (var i = 0; i < len; i++) {
        handleStyleAdded(addedNodes[i], ignoreStyleTagMap);
      }
      var remLen = removedNodes.length;
      for (var _i = 0; _i < remLen; _i++) {
        if (handleHotUpdate(removedNodes[_i], ignoreStyleTagMap)) {
          break;
        }
      }
    });
  });
  observer.observe(document.head, {
    childList: true
  });
}

/** @typedef {import('../index').IPlatformConfig} IPlatformConfig */
resetGlobalThis();
log$1("hel-micro-core ver ".concat(helConsts$1.CORE_VER));
var helEvents = helEvents$1,
  helLoadStatus = helLoadStatus$1,
  helConsts = helConsts$1;
var inectPlatToMod = inectPlatToMod$1;
var commonUtil = commonUtilMod;
var isSubApp = isSubApp$1;
function resetGlobalThis(globalThis) {
  if (globalThis) {
    setGlobalThis(globalThis);
  }
  // 载入此包就尝试设置 masterApp 锁，以推断自己是不是父应用
  tryMarkFlag(!!globalThis);
  // 确保 __HEL_MICRO_SHARED__ 存在
  ensureHelMicroShared();
  ensureHelMicroDebug();
  patchAppendChild();
  obStyleTagInsert();
}

/**
 * 获取默认的平台值
 * @returns
 */
var getPlatform = getPlatform$1,
  getSharedCache = getSharedCache$1;
var getHelDebug = getHelMicroDebug,
  allowLog = allowLog$1,
  log = log$1;
var getGlobalThis = getGlobalThis$1,
  setGlobalThis = setGlobalThis$1;
var getVerApp = getVerApp$1,
  setEmitApp = setEmitApp$1;
var getVerLib = getVerLib$1,
  setEmitLib = setEmitLib$1;
var getAppMeta = getAppMeta$1,
  setAppMeta = setAppMeta$1;
var getVersion = getVersion$1,
  setVersion = setVersion$1;
var getCustomData = getCustomData$1,
  setCustomData = setCustomData$1;
var getCommonData = getCommonData$1,
  setCommonData = setCommonData$1,
  commonDataUtil = commonDataUtil$1;
var getVerLoadStatus = getVerLoadStatus$1,
  setVerLoadStatus = setVerLoadStatus$1,
  getVerStyleStrStatus = getVerStyleStrStatus$1,
  setVerStyleStrStatus = setVerStyleStrStatus$1;
var getAppStyleStr = getAppStyleStr$1,
  setAppStyleStr = setAppStyleStr$1,
  getVerExtraCssList = getVerExtraCssList$1,
  setVerExtraCssList = setVerExtraCssList$1;
var tryGetVersion = tryGetVersion$1,
  tryGetAppName = tryGetAppName$1;
var getPlatformConfig = getPlatformConfig$1,
  getAppPlatform = getAppPlatform$1,
  setAppPlatform = setAppPlatform$1,
  initPlatformConfig = initPlatformConfig$1,
  originInit = originInit$1;
var getHelEventBus = getHelEventBus$1,
  getUserEventBus = getUserEventBus$1,
  evName = evName$1;
var libReady = libReady$1,
  appReady = appReady$1;

export { allowLog, appReady, commonDataUtil, commonUtil, evName, getAppMeta, getAppPlatform, getAppStyleStr, getCommonData, getCustomData, getGlobalThis, getHelDebug, getHelEventBus, getPlatform, getPlatformConfig, getSharedCache, getUserEventBus, getVerApp, getVerExtraCssList, getVerLib, getVerLoadStatus, getVerStyleStrStatus, getVersion, helConsts, helEvents, helLoadStatus, inectPlatToMod, initPlatformConfig, isSubApp, libReady, log, originInit, resetGlobalThis, setAppMeta, setAppPlatform, setAppStyleStr, setCommonData, setCustomData, setEmitApp, setEmitLib, setGlobalThis, setVerExtraCssList, setVerLoadStatus, setVerStyleStrStatus, setVersion, tryGetAppName, tryGetVersion };
